import { render } from "./post-guiderail.vue?vue&type=template&id=c8a75462&ts=true"
import script from "./post-guiderail.vue?vue&type=script&lang=ts"
export * from "./post-guiderail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__